/**
 * De afdelingen/machines en hun kleuren.
 *
 * De kleuren zijn de RGB-waarden uit de Excel en zijn vast: er is géén keuze meer
 * tussen een "verfijnd" palet en Excel RGB. Deze tabel is de enige kleurbron voor
 * de afdelingskleur, zowel in de API, de schermen als de PDF-export.
 *
 * Schuurderij en kalibreren zijn samengevoegd tot één afdeling `Schuurmachine`;
 * daarmee is er ook één route-stap `SCHUURMACHINE` die de calibreerdikte draagt.
 */
/** De zeven afdelingen, in routevolgorde zoals ze op het dashboard staan. */
export const AFDELINGEN = [
    'Fineerderij',
    'Winkel',
    'Zagerij',
    'Schuurmachine',
    'Pers',
    'Controle',
    'Gereed',
];
/** Afdelingskleur — Excel RGB, vast. */
export const AFDELINGSKLEUR = {
    Fineerderij: '#00B050',
    Winkel: '#0070C0',
    Zagerij: '#FFC000',
    Schuurmachine: '#7030A0',
    Pers: '#C00000',
    Controle: '#808080',
    Gereed: '#002060',
};
/** Leesbare tekstkleur op de afdelingskleur. */
export const AFDELINGSTEKST = {
    Fineerderij: '#ffffff',
    Winkel: '#ffffff',
    Zagerij: '#1a1a1a',
    Schuurmachine: '#ffffff',
    Pers: '#ffffff',
    Controle: '#ffffff',
    Gereed: '#ffffff',
};
/** Rework is altijd fel geel, ongeacht de afdeling waar de kar staat. */
export const REWORK = { kleur: '#FFFF00', tekst: '#1a1a1a', rand: '#d8c400' };
export const isAfdeling = (waarde) => AFDELINGEN.includes(waarde);
//# sourceMappingURL=afdelingen.js.map